import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import About from './pages/About';
import Vendors from './pages/Vendors';

const queryClient = new QueryClient();

// Placeholder components for legal pages
const PrivacyPolicy = () => (
  <div className="container mx-auto px-4 py-20">
    <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
    <p className="text-gray-600 mb-4">This privacy policy is currently being updated.</p>
    <p className="text-gray-600">Please contact us for more information about our data practices.</p>
  </div>
);

const TermsOfService = () => (
  <div className="container mx-auto px-4 py-20">
    <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
    <p className="text-gray-600 mb-4">Our terms of service are currently being updated.</p>
    <p className="text-gray-600">Please contact us for more information about our service terms.</p>
  </div>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/vendors" element={<Vendors />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Route>
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
